/* MUI */
import { Typography } from '@mui/material';

/*  React  */
import { CellContext } from '@tanstack/react-table';

/*  Shared  */
import { ScheduledReport as ScheduledReportType } from 'application/Shared/types/scheduledReport';

/* Hooks */
import { useFetchTenantSetting } from 'hooks/dataAccess/Tenant/tenantSetting';

/* React */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';

export const ReportTypeCell = ({
    row
}: CellContext<ScheduledReportType, unknown>): React.ReactElement => {
    const { t } = useTranslation();
    const { clientId } = useParams();

    const { setting: qbrToCBR } = useFetchTenantSetting({
        clientId,
        key: 'qbrToCBR'
    });

    const localizationString =
        row.original.params.type === 'qbr' && qbrToCBR
            ? `Reports.type.cbr`
            : `Reports.type.${row.original.params.type}`;

    return <Typography>{t(localizationString)}</Typography>;
};
